const Rules = {
    EMAILS  : 'emails',
}

export default Rules;